const TOSHI_CHARACTER_ID = "QW8eUlAKTTcLwX7nyKmY";

export const STORY_TEAM_CATALOG_LOOKUPS = Object.freeze({
  zay: Object.freeze(["zay"]),
  toshi: Object.freeze([TOSHI_CHARACTER_ID, "toshi"]),
  glyde: Object.freeze(["glyde"]),
});

const normalizeCatalogLookupValue = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const findStoryCatalogCharacter = (characterCards = [], lookupValues = []) => {
  const values = Array.isArray(lookupValues) ? lookupValues : [lookupValues];
  const normalizedLookups = values
    .map(normalizeCatalogLookupValue)
    .filter(Boolean);

  if (!normalizedLookups.length) return null;

  return (Array.isArray(characterCards) ? characterCards : []).find((card) => {
    const candidateValues = [
      card?.id,
      card?.sourceId,
      card?.characterId,
      card?.alias,
      card?.name,
    ]
      .map(normalizeCatalogLookupValue)
      .filter(Boolean);

    return normalizedLookups.some((lookup) => candidateValues.includes(lookup));
  }) || null;
};

export const resolveStoryTeammateCatalogCharacter = (
  characterKey = "",
  characterCards = [],
) =>
  findStoryCatalogCharacter(
    characterCards,
    STORY_TEAM_CATALOG_LOOKUPS[String(characterKey || "").trim().toLowerCase()] ||
      characterKey,
  );

const toBattleStat = (value) => {
  const numericValue = Number(value ?? 0);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const buildStoryCatalogCharacterStats = (catalogCharacter = null) => {
  if (!catalogCharacter) return null;

  return {
    health: toBattleStat(catalogCharacter?.health ?? catalogCharacter?.startingHealth),
    attack: toBattleStat(catalogCharacter?.attack ?? catalogCharacter?.startingAttack),
    defense: toBattleStat(catalogCharacter?.defense ?? catalogCharacter?.startingDefense),
    accuracy: toBattleStat(catalogCharacter?.accuracy ?? catalogCharacter?.startingAccuracy),
  };
};
